module.exports = "/images/vendor/@milestoneslabs/milestones-ui-kit/src/static/project-illustrations/homeOwnershipKey.svg?9461854058902fef1dbdea7ee5595344";